/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightExchangeAuthenticationRequest
 */
export interface FlightExchangeAuthenticationRequest {
  /**
   *
   * @type {string}
   * @memberof FlightExchangeAuthenticationRequest
   */
  paymentMethodId: string;
}

/**
 * Check if a given object implements the FlightExchangeAuthenticationRequest interface.
 */
export function instanceOfFlightExchangeAuthenticationRequest(
  value: object
): value is FlightExchangeAuthenticationRequest {
  if (!("paymentMethodId" in value) || value["paymentMethodId"] === undefined)
    return false;
  return true;
}

export function FlightExchangeAuthenticationRequestFromJSON(
  json: any
): FlightExchangeAuthenticationRequest {
  return FlightExchangeAuthenticationRequestFromJSONTyped(json, false);
}

export function FlightExchangeAuthenticationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeAuthenticationRequest {
  if (json == null) {
    return json;
  }
  return {
    paymentMethodId: json["payment_method_id"],
  };
}

export function FlightExchangeAuthenticationRequestToJSON(
  json: any
): FlightExchangeAuthenticationRequest {
  return FlightExchangeAuthenticationRequestToJSONTyped(json, false);
}

export function FlightExchangeAuthenticationRequestToJSONTyped(
  value?: FlightExchangeAuthenticationRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    payment_method_id: value["paymentMethodId"],
  };
}
